import React, { Fragment, useCallback, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import { withAreaGetter } from 'providers/AreasConsumers';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_SCORING } from 'constants/rightsCodes';

import ScoringCategoryContainer from './ScoringCategoryContainer';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const [disabledSave, setDisabledSave] = useState(true);
  const [onSave, setOnSave] = useState({ fn: () => {} });

  const scoringId = match.params.id && getInt(match.params.id);

  const onClickClose = () => {
    historyContext.push(`/scoringCategories`);
  };

  const onChangeTitle = scoringCategoryTitle => {
    setTitle(scoringCategoryTitle);
  };

  const onRedirect = useCallback(
    scoringId => {
      historyContext.push(`/scoringCategories/${scoringId}`);
    },
    [historyContext]
  );

  const onSaveFnChanged = useCallback((fn, disabledSave) => {
    setOnSave({ fn });
    setDisabledSave(disabledSave);
  }, []);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} disabledSave={disabledSave} onSave={onSave.fn} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_SCORING}>
        <ScoringCategoryContainer
          scoringId={scoringId}
          onChangeTitle={onChangeTitle}
          onRedirect={onRedirect}
          onSaveFnChanged={onSaveFnChanged}
        />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
